import React, { useState, useEffect } from "react";
import { getCreditSaleSheetEWise } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import {
  getAllPartySearch,
  getAllItemsSearch,
} from "../../../api/endpoints/search";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { Select } from "antd";
import { getAllVehical } from "../../../api/endpoints/vehical.js";

const { Option } = Select;

const CreditSaleSheetEWise = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [state, setState] = useState({
    parties: [],
    items: [],
    vehicle: [],
    startingDate: "",
    endingDate: "",
    partyId: "",
    partyName: "",
    vehicleId: "",
    vehicleNumber: "",
    itemCode: "",
    itemName: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  const clearFields = () => {
    setState({
      parties: state.parties,
      items: state.items,
      vehicle: state.vehicle,
      partyId: "",
      partyName: "",
      vehicleId: "",
      vehicleNumber: "",
      itemCode: "",
      itemName: "",
      endingDate: "",
      startingDate: "",
    });
  };
  const [loading, setLoading] = useState(false);

  const editHandler = async (e) => {
    if (!state.startingDate && !state.endingDate)
      return message.error("Please type date !");
    // if (!state.partyId) return message.error("Please Select Party!");
    let data = {
      startingDate: state.startingDate,
      endingDate: state.endingDate,
      partyId: state.partyId,
      itemCode: state.itemCode,
      vehicalId: state.vehicleId,
      siteId: Number(user.siteId),
    };
    try {
      setLoading(true); // disable button
      const results = await getCreditSaleSheetEWise(data, access_token);
      if (results.data.length === 0) {
        message.error("No Record Found in this date");
      }
      if (results.success) {
        const payload = results.data.reduce((acc, curr) => {
          return [
            ...acc,
            {
              enteredOn: curr.enteredOn,
              shift: curr.shift,
              partyId: Number(curr.partyId),
              partyName: curr.party.partyName,
              itemCode: Number(curr.itemCode),
              itemName: curr.item.itemName,
              vehicle: curr.vehical.regNumber,
              quantity: Number(curr.quantity),
              amount: Number(curr.amount),
              saleRate: Number(curr.saleRate),
              couponNo: curr.couponNo,
              siteId: curr.siteId,
            },
          ];
        }, []);
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _vehicles = await getAllVehical(access_token);
    const _parties = await getAllPartySearch(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
      vehicle: _vehicles,
    });
  };
  useEffect(() => {
    getAllData();
    getName();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");

    // ====== Header ======
    const now = new Date();
    const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    doc.setFontSize(8);
    doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
    doc.setFontSize(16);
    doc.text(`${siteName}`, 103, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(`${siteAddress}`, 103, 16, { align: "center" });
    doc.setFontSize(10);
    doc.text(
      `${state.partyName} From: ${formatDate(
        state.startingDate
      )} To ${formatDate(state.enteredOn)}`,
      103,
      20,
      {
        align: "center",
      }
    );

    data.sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn));
    const tableRows = data.map((r) => {
      return [
        r.enteredOn ? formatDateDDMMYYYY(r.enteredOn) : "",
        r.partyName || "",
        r.vehicle || "",
        r.couponNo || "",
        r.itemName || "",
        r.quantity.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        r.saleRate.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        r.amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      ];
    });

    // ====== Totals ======
    const totalQty = data.reduce(
      (sum, r) => sum + (Number(r.quantity) || 0),
      0
    );
    const totalAmount = data.reduce(
      (sum, r) => sum + (Number(r.amount) || 0),
      0
    );

    tableRows.push([
      "",
      "",
      "",
      "",
      "Total",
      totalQty.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      "",
      totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    ]);

    // ====== Render AutoTable ======
    autoTable(doc, {
      head: [
        [
          "Date",
          "Party Name",
          "Vehicle",
          "Coupon No",
          "Item",
          "Quantity",
          "SRate",
          "Amount",
        ],
      ],
      body: tableRows,
      startY: 25,
      theme: "grid",
      margin: { left: 1, right: 2 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 15 }, // Date
        1: { halign: "left", cellWidth: 55 }, // Party Name
        2: { halign: "center", cellWidth: 30 }, // Vehicle
        3: { halign: "center", cellWidth: 25 }, // Coupon No
        4: { halign: "left", cellWidth: 15 }, // Item
        5: { halign: "right", cellWidth: 20 }, // Quantity
        6: { halign: "right", cellWidth: 15 }, // SRate
        7: { halign: "right", cellWidth: 25 }, // Amount
      },

      didParseCell: (data) => {
        // Make last row (Total) bold
        if (data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    // ====== Open PDF in new tab ======
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-10">
            <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Credit Sale Sheet </h1>
              </div>
              <div className="flex flex-col content-center items-center justify-items-center justify-evenly">
                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-white" htmlFor="startDate">
                      Starting Date:
                    </label>
                    <input
                      type="date"
                      name="startingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                    <label className="text-white ml-5" htmlFor="endDate">
                      Ending Date:
                    </label>
                    <input
                      type="date"
                      name="endingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    placeholder="Party Code"
                    optionFilterProp="children"
                    value={state.partyId || "Party Code"}
                    onChange={(e) => {
                      const lCode = state.parties.find(
                        (el) => el.partyId === e
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: lCode.PartyName,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId} key={el.partyId}>
                        {el.partyId}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    placeholder="Party Name"
                    optionFilterProp="children"
                    value={state.partyName || "Party Name"}
                    onChange={(e) => {
                      const lCode = state.parties.find(
                        (el) => el.partyId === e
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: lCode.PartyName,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId} key={el.partyId}>
                        {`${el.partyId} - ${el.PartyName}`}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <Select
                    showSearch
                    placeholder="Select item"
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    optionFilterProp="children"
                    value={state.itemCode || "Item"}
                    onChange={(e) => {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }}
                  >
                    {state.items.map((el) => (
                      <Option value={el.itemCode}>{el.itemCode}</Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    placeholder="Select Product Name"
                    optionFilterProp="children"
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    value={state.itemName || "Prodct Name"}
                    onChange={(e) => {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }}
                  >
                    {state.items.map((el) => (
                      <Option
                        value={el.itemCode}
                      >{`${el.itemCode} - ${el.itemName}`}</Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <Select
                    showSearch
                    placeholder="Select Vehical"
                    className="mt-2 ml-3 h-8 p-1 w-36"
                    optionFilterProp="children"
                    value={state.vehicleId || "Vehical"}
                    onChange={(e) => {
                      const { regNumber: regNumber } = state.vehicle.find(
                        (el) => el.id === e
                      );
                      setState({
                        ...state,
                        vehicleId: e,
                        vehicleNumber: regNumber,
                      });
                    }}
                  >
                    {state.vehicle.map((el) => (
                      <Option value={el.id}>{el.id}</Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    placeholder="Select Vehicle Name"
                    optionFilterProp="children"
                    className="mt-2 ml-3 h-8 p-1 w-60"
                    value={state.vehicleNumber || "Vehicle Name"}
                    onChange={(e) => {
                      const { regNumber: productName } = state.vehicle.find(
                        (el) => el.id === e
                      );
                      setState({
                        ...state,
                        vehicleId: e,
                        vehicleNumber: productName,
                      });
                    }}
                  >
                    {state.vehicle.map((el) => (
                      <Option value={el.id}>{`${el.regNumber}`}</Option>
                    ))}
                  </Select>
                </div>
                <div className="pb-3 pt-3">
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button
                    onClick={clearFields}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditSaleSheetEWise;
